import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Grid, TextField, FormHelperText } from '@material-ui/core'
import EventIcon from '@material-ui/icons/Event'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { FirebaseConfigKey, FirebaseService } from '../../services/FirebaseService'
import NewFillButton from '../Core/NewFillButton'

export const DairylandCustomerForm = ({ onSubmitForm, hidden, defaultValues }) => {
  const { errors, getValues, register, setValue, watch, control, handleSubmit } = useForm({
    mode: 'onSubmit',
    defaultValues: defaultValues,
  })
  const onSubmit = data => {
    onSubmitForm(data)
  }

  return (
    <>
      {!hidden && (
        <Grid item xs={12} className="margin-bottom-24">
          <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <Grid container className="font-normal flex flex-col">
              <Grid item xs={4} className="margin-bottom-24">
                <Controller
                  as={
                    <KeyboardDatePicker
                      disableFuture={false}
                      keyboardIcon={<EventIcon className="backbuttongray" />}
                      openTo="year"
                      views={['year', 'month', 'date']}
                      label={'Effective date'}
                      inputVariant="outlined"
                      error={errors.effective_date}
                      format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
                    />
                  }
                  onChange={date => {
                    if (date && date.length > 0 && date[0] != null) {
                      setValue('effective_date', new Date(date[0]))
                      return new Date(date[0]) //important to update the controller value after change else state is updated and the controller will not render
                    } else {
                      setValue('effective_date', null)
                      return getValues()['effective_date']
                    }
                  }}
                  name="effective_date"
                  value={watch('effective_date')}
                  defaultValue={watch('effective_date')}
                  control={control}
                  rules={{
                    required: 'Effective date is required',
                    validate: value =>
                      !value ||
                      !getValues('purchase_date') ||
                      new Date(value) >= new Date(getValues('purchase_date')) ||
                      'Effective date cannot be before the purchase date',
                  }}
                />
                {errors.effective_date && (
                  <FormHelperText error style={{ marginLeft: 14 }}>
                    {errors.effective_date.message}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4} className="margin-bottom-24">
                <Controller
                  as={
                    <KeyboardDatePicker
                      disableFuture
                      keyboardIcon={<EventIcon className="backbuttongray" />}
                      openTo="year"
                      views={['year', 'month', 'date']}
                      label={'Purchase date'}
                      inputVariant="outlined"
                      format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
                      error={errors.purchase_date}
                    />
                  }
                  onChange={date => {
                    if (date && date.length > 0 && date[0] != null) {
                      setValue('purchase_date', new Date(date[0]))
                      return new Date(date[0]) //important to update the controller value after change else state is updated and the controller will not render
                    } else {
                      setValue('purchase_date', null)
                      return getValues()['purchase_date']
                    }
                  }}
                  name="purchase_date"
                  value={watch('purchase_date')}
                  defaultValue={watch('purchase_date')}
                  control={control}
                  rules={{ required: 'Purchase date is required' }}
                />
                {errors.purchase_date && (
                  <FormHelperText error style={{ marginLeft: 14 }}>
                    {errors.purchase_date.message}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4} className="margin-bottom-24">
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Enter premium value ($)"
                  type="number"
                  name="premium"
                  inputProps={{ min: '0', step: '0.01' }}
                  inputRef={register({ required: 'Premium value is required' })}
                  error={!!errors.premium}
                  helperText={errors.premium ? errors.premium.message : ''}
                  InputLabelProps={{ className: 'avenir-book' }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  className="margin-top-basic"
                  label="Comment"
                  name="comment"
                  multiline
                  inputRef={register()}
                  InputLabelProps={{ className: 'avenir-book' }}
                  rows={4}
                />
              </Grid>

              <Grid item xs={12} className="flex-end flex">
                <NewFillButton onClick={handleSubmit(onSubmit)}>Save</NewFillButton>
              </Grid>
            </Grid>
          </form>
        </Grid>
      )}
    </>
  )
}
